import ThemeProvider from './components/ThemeProvider/ThemeProvider'
import './index.scss'
import App from './pages/App/App'
import rootReducer from './reducers/rootReducer'
import { unregister } from './registerServiceWorker'
import muiTheme from './theme/muiTheme'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider as Mui5ThemeProvider } from '@mui/material/styles'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import 'mapbox-gl/dist/mapbox-gl.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Helmet from 'react-helmet'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

if (process.env.NODE_ENV === 'development') {
  // Code that should only run in development (local)
  console.log('Running in local environment. Disabling sentry...')

  // Suppress noisy deprecation warnings from third-party libraries
  // (MUI v3, react-router v5, react-redux v5, react-transition-group,
  // react-helmet) that we can't fix without migrating off those versions.
  const noisyPatterns = [
    'legacy contextTypes API',
    'legacy childContextTypes API',
    'componentWillMount has been renamed',
    'componentWillReceiveProps has been renamed',
    'Support for defaultProps will be removed',
    'deprecated typography variants',
    'findDOMNode is deprecated',
    'React.createFactory() is deprecated',
  ]
  const matchesNoise = (args) => {
    const first = typeof args[0] === 'string' ? args[0] : ''
    return noisyPatterns.some((p) => first.includes(p))
  }
  const origError = console.error
  console.error = function (...args) {
    if (matchesNoise(args)) return
    origError.apply(console, args)
  }
  const origWarn = console.warn
  console.warn = function (...args) {
    if (matchesNoise(args)) return
    origWarn.apply(console, args)
  }
} else {
  Sentry.init({
    dsn: 'https://a23a7a74716e4640a7bfd5008d71ece6@o445902.ingest.sentry.io/6571347',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}
const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(thunk),
    process.env.NODE_ENV === 'development' &&
      window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
)

if (module.hot) {
  module.hot.accept()
}

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <Mui5ThemeProvider theme={muiTheme}>
        <Helmet>
          <meta name="version" content={process.env.REACT_APP_VERSION} />
        </Helmet>
        <CssBaseline />
        <App />
      </Mui5ThemeProvider>
    </ThemeProvider>
  </Provider>
)

unregister()
